import React, { useEffect } from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import "../PolicyLayout.css";

const Legal = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* Policy pages पर forceSolid=true दें */}
      <Header forceSolid={true} />

      <div className="policy-page">
        <div className="policy-container">
          <h1 className="policy-title">Legal Information</h1>

          <h2>Terms and Conditions</h2>
          <p>
            Our Terms and Conditions outline the rules and regulations for using
            our website. It includes information on user responsibilities,
            copyright notices, and disclaimers regarding the accuracy of
            information and materials found on the website. It is important to
            read and understand these terms before using our services.
          </p>

          <h2>Privacy Policy</h2>
          <p>
            Your privacy is of utmost importance to us. This policy details the
            types of personal information we collect and how it is used. We
            ensure that your data is handled responsibly and in compliance with
            applicable privacy laws. Our policy also covers information about
            cookies, third-party links, and data security measures.
          </p>

          <h2>Cookie Policy</h2>
          <p>
            Cookies are small data files used to enhance your browsing
            experience. Our Cookie Policy explains how we use cookies to improve
            our website's functionality, analyze traffic patterns, and
            personalize content. You can choose to accept or decline cookies.
          </p>

          <h2>Intellectual Property Rights</h2>
          <p>
            The content on our website, including text, graphics, logos, and
            images, is our property or the property of our content suppliers and
            is protected by intellectual property laws. Unauthorized use,
            reproduction, or distribution of this material is strictly
            prohibited.
          </p>

          <h2>Disclaimers</h2>
          <p>
            While we strive to provide accurate and up-to-date information, we
            cannot guarantee that all content on our website is always correct
            or complete. We disclaim liability for any inaccuracies, errors, or
            omissions in the content provided.
          </p>

          <h2>Compliance and Regulations</h2>
          <p>
            We are committed to adhering to all relevant laws and regulations
            governing our operations. This includes compliance with consumer
            protection laws, e-commerce regulations, and applicable
            industry-specific guidelines.
          </p>

          <h2>Accessibility Statement</h2>
          <p>
            We believe in making our website accessible to everyone, including
            individuals with disabilities. Our Accessibility Statement outlines
            the steps taken to ensure our website is user-friendly and compliant
            with accessibility standards.
          </p>

          <h2>Contact Information</h2>
          <p>
            For legal inquiries or more information, please contact us at{" "}
            <strong>support@wonder-theme.com</strong>.
          </p>
        </div>
      </div>

      {/* <Footer /> */}
    </>
  );
};

export default Legal;